import { MB_SVG_Check, MB_SVG_X } from '@/components/general/svg-components';
import React from 'react';
import { View, StyleSheet, StyleProp, ViewStyle, Text } from 'react-native';
import { COLORS } from './constants';
import { MB_ToolTipWrapper, TOOLTIP_ARROW_DIRECTION } from './MB_ToolTipWrapper';

const MB_PasswordToolTip = (props: {
  /**
   * Style of the container.
   */
  containerStyle?: StyleProp<ViewStyle>;

  /**
   * List of error messages.
   */
  errorArray: {
    /**
     * Error message.
     */
    message: string;

    /**
     * Whether there is an error or not.
     */
    isError: boolean;
  }[];

  /**
   * Direction of the arrow.
   */
  arrowDirection?: TOOLTIP_ARROW_DIRECTION;

  /**
   * Color of the arrow.
   */
  arrowColor?: string;
}) => {
  const PasswordCorrectnessIndicators = ({ errorString, isError }: { errorString: string; isError: boolean }) => {
    return (
      <View style={styles.correctnessIndicatorWrapper}>
        {isError ? <MB_SVG_X color={COLORS.offRed} size={12} /> : <MB_SVG_Check color={COLORS.greenishBlue} size={12} />}
        <Text style={styles.correctnessIndicatorText}>{errorString}</Text>
      </View>
    );
  };

  return (
    <MB_ToolTipWrapper containerStyle={[styles.container, props.containerStyle]} arrowDirection={props.arrowDirection} arrowColor={props.arrowColor}>
      <Text style={styles.title}>Your password must contain the following</Text>
      {props.errorArray.map((err, index) => (
        <PasswordCorrectnessIndicators key={index} errorString={err.message} isError={err.isError} />
      ))}
    </MB_ToolTipWrapper>
  );
};

export { MB_PasswordToolTip };

const styles = StyleSheet.create({
  container: {
    backgroundColor: COLORS.white,
    width: 218,
    paddingVertical: 14,
    paddingHorizontal: 16,
  },
  title: {
    textAlign: 'left',
    color: COLORS.titleColor,
    fontWeight: 'normal',
    fontSize: 12,
  },
  correctnessIndicatorWrapper: {
    flexDirection: 'row',
    marginTop: 4,
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  correctnessIndicatorText: {
    textAlign: 'left',
    color: COLORS.correctnessTextColor,
    marginStart: 8,
    fontWeight: 'normal',
    fontSize: 12,
  },
});
